import React from "react";
import { useNavigate } from "react-router-dom";

export default function LoginRoleSelect() {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <div style={styles.overlay} />

      <div style={styles.container}>
        <div style={styles.headerWrap}>
           {/* <h1 className="login-title">SIMAM</h1> */}
           <h1 className="login-title">Sistem Implementasi Adab Murid</h1>
          <div style={styles.logo}>🎓</div>
          
          <h1 style={styles.title}>Pilih Jenis Login</h1>
          <p style={styles.subtitle}>
            Silakan pilih peran untuk melanjutkan ke halaman login
          </p>
        </div>

        <div style={styles.grid}>
          {/* Card Siswa */}
          <button
            type="button"
            style={styles.card}
            onClick={() => navigate("/student")}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow =
                "0 16px 35px rgba(79,70,229,0.18)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 10px 25px rgba(15,23,42,0.08)";
            }}
          >
            <div style={styles.iconWrap}>🧑‍🎓</div>
            <h2 style={styles.cardTitle}>Login sebagai Siswa</h2>
            <p style={styles.cardDesc}>
              Masuk menggunakan nama siswa dan passcode siswa.
            </p>
            <span style={styles.badge} >Siswa</span>
          </button>

          {/* Card Orang Tua */}
          <button
            type="button"
            style={styles.card}
            onClick={() => navigate("/parent")}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow =
                "0 16px 35px rgba(79,70,229,0.18)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 10px 25px rgba(15,23,42,0.08)";
            }}
          >
            {/* <div style={styles.iconWrap}>👨‍👩‍👧‍👦</div> */}
           <div style={styles.iconWrap}>🧕🏼</div>
            <h2 style={styles.cardTitle}>Login sebagai Orang Tua</h2>
            <p style={styles.cardDesc}>
              Masuk menggunakan akun akses orang tua/wali.
            </p>
            <span style={styles.badge}>Orang Tua</span>
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
    background:
      "linear-gradient(135deg, #EEF2FF 0%, #E0E7FF 35%, #F8FAFC 100%)",
    fontFamily:
      'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    overflow: "hidden",
  },
  overlay: {
    position: "absolute",
    inset: 0,
    background:
      "radial-gradient(circle at 20% 20%, rgba(79,70,229,0.15), transparent 35%), radial-gradient(circle at 80% 80%, rgba(14,165,233,0.12), transparent 35%)",
    pointerEvents: "none",
  },
  container: {
    width: "100%",
    maxWidth: "980px",
    zIndex: 1,
  },
  headerWrap: {
    textAlign: "center",
    marginBottom: "28px",
  },
  logo: {
    width: "64px",
    height: "64px",
    borderRadius: "16px",
    margin: "0 auto 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "30px",
    background: "#EEF2FF",
    boxShadow: "0 8px 20px rgba(79,70,229,0.18)",
  },
  title: {
    margin: 0,
    fontSize: "34px",
    fontWeight: 800,
    color: "#1F2937",
    lineHeight: 1.2,
  },
  subtitle: {
    margin: "8px 0 0",
    color: "#6B7280",
    fontSize: "15px",
    fontWeight: 500,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "16px",
  },
  card: {
    border: "1px solid #E5E7EB",
    borderRadius: "18px",
    padding: "22px",
    background: "#FFFFFF",
    textAlign: "left",
    cursor: "pointer",
    transition: "all 0.22s ease",
    boxShadow: "0 10px 25px rgba(15,23,42,0.08)",
  },
  iconWrap: {
    width: "46px",
    height: "46px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#EEF2FF",
    fontSize: "22px",
    marginBottom: "14px",
  },
  cardTitle: {
    margin: "0 0 8px",
    fontSize: "22px",
    fontWeight: 800,
    color: "#111827",
  },
  cardDesc: {
    margin: "0 0 14px",
    fontSize: "14px",
    color: "#6B7280",
    lineHeight: 1.5,
  },
  badge: {
    display: "inline-block",
    fontSize: "12px",
    fontWeight: 700,
    color: "#4F46E5",
    background: "#EEF2FF",
    borderRadius: "999px",
    padding: "6px 10px",
  },
};
